import { render } from "./ProductOrder.vue?vue&type=template&id=fc6ebe60"
import script from "./ProductOrder.vue?vue&type=script&lang=js"
export * from "./ProductOrder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__